import { appWaveScannerDetails } from "../../apis";
import { getDecryptLocalStorage, getStorageWithMultiTabCheck } from "../../utils/global_functions";
import { ALL_COMBINED_SCREENERS, BUSINESS_LAYER_RESPONSE,DERV_CUR_COMMODITY_SCREENERS,DERV_CUR_SCREENERS,EQUITY_CUR_SCREENERS,EQUITY_DERV_SCREENERS,EQUITY_SCREENERS,EXCHANGE_NAME_API,LOCAL_STORAGE_KEYS,NOT_INCLUDED_GROUPS } from "../../utils/global_variables";


const exchangeAllowed = (segment) => {
    let objLoginSession = JSON.parse(getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
    //Vaibhav S: 11-06-2025: bcast logic added as discussed with akshay screener will not appear in case of marketwatch and trading allowed of
    if (objLoginSession?.data?.exchanges?.includes(segment)||objLoginSession?.data?.bcastExchanges?.includes(segment)) {
        return true;
    } else {
        return false;
    }
};

async function _getAppWaveScannerDetails() {

    try {
        //Vaibhav Singh: 06-03-24:Added filteration for data from api: Start
        const objResp = await appWaveScannerDetails();
        let filteredArray = objResp?.data?.result?.filter(obj => !NOT_INCLUDED_GROUPS.includes(obj.Category)&&!["PCR"].includes(obj.GroupName))
        let isEquityAllowed = exchangeAllowed(EXCHANGE_NAME_API.NSE_EQ_API)||exchangeAllowed(EXCHANGE_NAME_API.BSE_EQ_API)||exchangeAllowed(EXCHANGE_NAME_API.MSE_EQ_API)
        let isDerivativeAllowed = exchangeAllowed(EXCHANGE_NAME_API.NSE_DERV_API)||exchangeAllowed(EXCHANGE_NAME_API.BSE_DERV_API)
        let isCurrencyAllowed = exchangeAllowed(EXCHANGE_NAME_API.NSX_DERV_API)||exchangeAllowed(EXCHANGE_NAME_API.BSECDX_DERV_API)
        let isCommodityallowed = exchangeAllowed(EXCHANGE_NAME_API.MCX_DERV_API)||exchangeAllowed(EXCHANGE_NAME_API.ICEX_DERV_API)||exchangeAllowed(EXCHANGE_NAME_API.NCDEX_DERV_API)||exchangeAllowed(EXCHANGE_NAME_API.NSE_COMM_API)||exchangeAllowed(EXCHANGE_NAME_API.BSE_COMM_API)
        if(!isEquityAllowed){
            filteredArray = filteredArray?.filter(e=>!EQUITY_SCREENERS.includes(e?.GroupId)) 
        }
        if(!isEquityAllowed && !isDerivativeAllowed){
            filteredArray = filteredArray?.filter(e=>!EQUITY_DERV_SCREENERS.includes(e?.GroupId))
        }
        if(!isEquityAllowed && !isCurrencyAllowed){
            filteredArray = filteredArray?.filter(e=>!EQUITY_CUR_SCREENERS.includes(e?.GroupId))
        }
        if(!isCurrencyAllowed && !isCurrencyAllowed){
            filteredArray = filteredArray?.filter(e=>!DERV_CUR_SCREENERS.includes(e?.GroupId))
        }
        if(!isCurrencyAllowed && !isCurrencyAllowed && !isCommodityallowed){
            filteredArray = filteredArray?.filter(e=>!DERV_CUR_COMMODITY_SCREENERS.includes(e?.GroupId))
        }
        if(!isCurrencyAllowed && !isCurrencyAllowed && !isCommodityallowed && !isEquityAllowed){
            filteredArray = filteredArray?.filter(e=>!ALL_COMBINED_SCREENERS.includes(e?.GroupId))
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: filteredArray };
        //Vaibhav Singh: 06-03-24:Added filteration for data from api: End
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };

    }
}

export { _getAppWaveScannerDetails };